import { motion } from "framer-motion";
import { TiTick } from "react-icons/ti";
import GetAQuoteButton from "../../../../components/GetAQuoteButton";
import { Link } from "react-router-dom";
import { routes } from "../../../../config/utilities/utils.constant";

export const RefiningContent = () => {
  return (
    <section className="container">
      <div className=" space-y-14 bg-[#f3ebfa] px-5 md:px-10 lg:px-20 py-10 rounded-3xl">
        <div className="space-y-4">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] text-center  font-bold text-dark font-butler"
          >
            Refining AI-Generated Code and Legacy Systems
          </motion.h2>
          <div className="space-y-4">
            <p className="text-base leading-[1.625rem]">
              Many small businesses struggle with AI-generated prototypes or
              legacy monoliths that cannot scale and lack security. Our
              specialized teams excel at AI-cleanup, where we transform vibe
              code into enterprise-grade software. We focus on refactoring
              architectures into microservices and implementing Docker
              containers to ensure your application is resilient and ready for
              high-traffic environments. This approach eliminates the technical
              debt that often cripples rapid-growth startups.
            </p>
          </div>
        </div>
        <div className="space-y-4">
          <motion.h3
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[25px] md:text-[30px] lg:text-[35px] xl:text-[40px] 2xl:text-[40px] !leading-[1.2]   text-center  font-bold text-dark font-butler"
          >
            Why Partner With Our Developers over AI-Generated Solutions
          </motion.h3>
          <div className="space-y-4">
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>
                <span className="text-lg font-bold text-dark inline">
                  Consultative Experience:{" "} 
                </span>
                <p className="text-base leading-[1.625rem] text-dark inline">
                  Our team provides deep industry expertise that AI cannot
                  replicate, ensuring your project meets real-world business
                  objectives.{" "}
                </p>
              </div>
            </div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>
                <span className="text-lg font-bold text-dark inline">
                  Expert System Architecture:{" "} 
                </span>
                <p className="text-base leading-[1.625rem] text-dark inline">
                  We architect intricate systems designed for high-load
                  environments, moving far beyond the simple logic found in AI
                  code.{" "}
                </p>
              </div>
            </div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>
                <span className="text-lg font-bold text-dark inline">
                  {" "}
                  Future-Proof Engineering:{" "} 
                </span>
                <p className="text-base leading-[1.625rem] text-dark inline">
                  {" "}
                  Get clean and maintainable code that avoids the technical debt
                  and scaling limitations common in automated prototypes.{" "}
                </p>
              </div>
            </div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>
                <span className="text-lg font-bold text-dark inline">
                  Resilient Implementations:{" "} 
                </span>
                <p className="text-base leading-[1.625rem] text-dark inline">
                  {" "}
                  Avoid expensive re-writes later by investing in a professional
                  implementation from the very beginning.{" "}
                </p>
              </div>
            </div>
            <div className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>
                <span className="text-lg font-bold text-dark inline">
                  Seamless Maintenance:{" "} 
                </span>
                <p className="text-base leading-[1.625rem] text-dark inline">
                  {" "}
                  Enjoy a stress-free deployment and ongoing support handled by
                  experts who understand every single line of your code.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <motion.h4
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[25px] md:text-[30px] lg:text-[30px] text-center  font-bold text-dark font-butler  leading-7 md:leading-10"
          >
            Scale your business with a robust web app designed for measurable
            growth{" "}
          </motion.h4>
          <div className="space-y-4">
            <p className="text-base leading-[1.625rem] text-center">
              Turn your complex workflows into an efficient, future-proof
              digital asset.
            </p>
            <div className="flex justify-center">
             
              <Link
                          to={routes.CONTACTUS}
                          aria-label="Internal link to Contact Us page"
                        >
                          <button 
                title="Get a Free Technical Consultation"
                            className="  px-6 py-4 bg-[#FFC067] text-dark font-bold rounded shadow text-base  md:text-lg transition  hover-filled text-center"
                          > 
Get a Free Technical Consultation                          </button>
                        </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
